/* eslint-disable import/no-import-module-exports -- old code */
import { fromJS } from 'immutable';
import Cookies from 'js-cookie';
import { browserHistory } from '@americanexpress/one-app-router';
import { clean, normalizeApiUrl, getRegionFromLocale } from './utils';
import reportError from './reportError';
import reportApplicationError from './reportApplicationError';
import fetchWithReporter, { createFetchWithReporter } from './fetchWithReporter';
import {
  getActiveLocale,
  getLoginConfig,
  getLoginUsApiDomainConfig,
  getLogSuccess,
} from './selectors';
/* eslint-enable import/no-import-module-exports -- old code */
export {
  fetchWithReporter,
  createFetchWithReporter,
  reportError,
  reportApplicationError,
};

export * as procedures from './procedures';

export * as selectors from './selectors';

export const SESSION_EXTEND_REQUEST = 'global/auth/EXTEND_REQUEST';
export const SESSION_EXTEND_SUCCESS = 'global/auth/EXTEND_SUCCESS';
export const SESSION_EXTEND_FAILURE = 'global/auth/EXTEND_FAILURE';

export const SESSION_END_SUCCESS = 'global/auth/END_SUCCESS';
export const SESSION_END_FAILURE = 'global/auth/END_FAILURE';

export const LOGOUT_REQUEST = 'global/auth/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'global/auth/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'global/auth/LOGOUT_FAILURE';

export const LOGIN_REQUEST = 'global/auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'global/auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'global/auth/LOGIN_FAILURE';

export const UNAUTHENTICATED = 'global/auth/UNAUTHENTICATED';
export const AUTHENTICATED = 'global/auth/AUTHENTICATED';

export const SET_LOCAL_DELTA = 'global/auth/SET_LOCAL_DELTA';

export const SET_DEST_PAGE = 'global/auth/SET_DEST_PAGE';
export const CLEAR_DEST_PAGE = 'global/auth/CLEAR_DEST_PAGE';

export const AUTH_UPDATE = 'global/auth/AUTH_UPDATE';
export const LOGIN_RESET_STATUS = 'modules/one-identity-login/RESET_STATUS';
export const SSO_LOGIN_REQUEST = 'global/auth/SSO_LOGIN_REQUEST';
export const LEGACY_LOGIN_REQUEST = 'global/auth/LEGACY_LOGIN_REQUEST';

export const ALERT_LOGOFF = 'logoff';
export const ALERT_AUTO_LOGOFF = 'logoffAuto';

export const CONTENT_FORM_URL_ENCODED = 'application/x-www-form-urlencoded; charset=utf-8';

// TODO is using JSON
// const CONTENT_TYPE_JSON = 'application/json; charset=UTF-8';
export const REAUTH_ERROR_CODE = 'LGON008';

export const enabledLocales = [
  'de-AT',
  'de-CH',
  'de-DE',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-HK',
  'en-IN',
  'en-NZ',
  'en-SG',
  'en-US',
  'en-XA',
  'en-XB',
  'es-ES',
  'fi-FI',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-FR',
  'it-IT',
  'ja-JP',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'sv-SE',
  'zh-HK',
];

const enabledLocalesLowercase = enabledLocales.map((locale) => locale.toLowerCase());

export function isSessionCookieValid(req) {
  const amexSessionCookie = !global.BROWSER ? req && req.cookies.amexsessioncookie : Cookies.get('amexsessioncookie');
  if (amexSessionCookie) {
    const timeNow = new Date().getTime();
    const match = /uts=([^|]+)/.exec(amexSessionCookie);
    if (!match) { return false; }
    // eslint-disable-next-line unicorn/prefer-number-properties  -- old code
    const cookieTimeStamp = parseInt(match[1], 10);
    const diff = (timeNow - cookieTimeStamp) / (1000 * 60);
    return diff <= 10;
  }
  return false;
}

export function buildInitialState({ req } = {}) {
  return fromJS({
    loginLoading: false,
    sessionLoading: false,
    session: isSessionCookieValid(req) ? Date.now() : null,
    login: isSessionCookieValid(req) ? Date.now() : null,
    keep: false,
  });
}
export const initialState = buildInitialState();

// eslint-disable-next-line default-param-last -- old code
const reducer = (state = buildInitialState(), action) => {
  switch (action.type) {
    case SESSION_EXTEND_REQUEST:
      return state.set('sessionLoading', true);
    case SESSION_EXTEND_SUCCESS:
      return state.merge({
        sessionLoading: false,
        session: Date.now(),
        keep: false,
      });
    case SESSION_EXTEND_FAILURE:
      return state
        .set('sessionLoading', false)
        .set('login', null);
    case LOGOUT_SUCCESS:
      return state.set('sessionLoading', false);
    case LOGOUT_FAILURE:
      return state.set('sessionLoading', false);
    case LOGIN_REQUEST:
      return state.merge({
        loginLoading: true,
        logout: null,
        auto: null,
      });
    case LOGIN_SUCCESS:
      return state.merge({
        loginLoading: false,
        login: Date.now(),
        session: action.data.statusCode === 0 ? Date.now() : null,
        status: fromJS(action.data),
      });
    case LOGIN_FAILURE:
      return state.merge({
        loginLoading: false,
        login: null,
        status: fromJS({ statusCode: 1, errorCode: 'LGON010' }),
      });
    case AUTHENTICATED:
      if (state.get('login')) return state;
      return state.set('login', Date.now());
    case UNAUTHENTICATED:
      return state.set('login', null);
    case SET_LOCAL_DELTA:
      return state
        .set('delta', action.delta);
    case SET_DEST_PAGE:
      return state.set('destPage', action.destPage);
    case CLEAR_DEST_PAGE:
      return state.delete('destPage');
    case AUTH_UPDATE:
      return state.merge(fromJS(action.data));
    default:
      return state;
  }
};

export const updateAuthState = (data) => ({
  type: AUTH_UPDATE,
  data,
});

export function storageMessageHandler(e) {
  // can't use autoLogoff because it may not change value, and will not trigger
  if (e.key === 'logoff') {
    exports.reload();
  }
}

export function initialize() {
  if (global.BROWSER) {
    window.addEventListener('storage', storageMessageHandler, false);
    try {
      window.localStorage.removeItem('preAlert');
    } catch (err) {
      // ignore localStorage unsupported
    }
  }
}

export function isLoginEnabled(locale) {
  return enabledLocalesLowercase.indexOf(locale.toLowerCase()) >= 0;
}

export function loginFaceMapper(locale) {
  const faceMap = {
    en_XA: 'en_EI',
    en_XB: 'en_EU',
    nb_NO: 'no_NO',
  };

  if (faceMap[locale]) {
    return faceMap[locale];
  }

  return locale;
}

export function faceMapper(locale) {
  const faceMap = {
    en_XA: 'en_EI',
    en_XB: 'en_EU',
    nb_NO: 'no_NO',
    zh_HK: 'ch_HK',
  };

  if (faceMap[locale]) {
    return faceMap[locale];
  }

  return locale;
}

export const preload = (auto) => {
  const defaultAlertType = auto ? ALERT_AUTO_LOGOFF : ALERT_LOGOFF;

  try {
    const alertType = window.localStorage.getItem('preAlert') || defaultAlertType;
    window.localStorage.setItem('alertType', alertType);
    window.localStorage.setItem('alertTimestamp', Date.now());
  } catch (err) {
    // ignore localStorage unsupported
  }
};

export function reload() {
  if (global.BROWSER) {
    // eslint-disable-next-line unicorn/prefer-add-event-listener -- used for test logic
    window.onbeforeunload = undefined;
    window.location.reload();
  }
}

export function getLoginConfigByRegion(region) {
  return region === 'us' ? 'loginUsApiDomain' : 'loginIntlApiDomain';
}

const urlEncodeForm = (obj) => Object.keys(obj).map((key) => {
  const encKey = encodeURIComponent(key);
  const encValue = encodeURIComponent(`${obj[key]}`); // force number, boolean to string
  return `${encKey}=${encValue}`;
}).join('&');

export function postLogout(locale, loginConfig) {
  const formData = {
    request_type: 'logoff',
    Face: loginFaceMapper(locale.replace('-', '_')),
  };

  const content = urlEncodeForm(formData);
  return fetch(`${normalizeApiUrl(loginConfig)}/myca/logon/us/action/logoff`, {
    method: 'POST',
    headers: {
      'Content-Type': CONTENT_FORM_URL_ENCODED,
    },
    credentials: 'include',
    body: content,
  });
}

export function rememberMe(remember) {
  return remember ? 'on' : 'off';
}

export function postLogin({
  userId,
  password,
  remember,
  locale,
  transactionId,
  destination,
  applicationId = '',
  mfaId,
  channel,
  challengeable,
}) {
  const region = getRegionFromLocale(locale) || 'us';
  const now = new Date();
  const formData = clean({
    request_type: 'login',
    Face: loginFaceMapper(locale.replace('-', '_')),
    Logon: 'Logon',
    version: '4',
    inauth_profile_transaction_id: transactionId,
    DestPage: destination,
    applicationId,
    UserID: userId,
    Password: password,
    mfaId,
    channel,
    ...remember !== undefined && { REMEMBERME: rememberMe(remember) },
    // additional fields requested by Ravi Musani 8/22/2019
    b_hour: now.getHours(),
    b_minute: now.getMinutes(),
    b_second: now.getSeconds(),
    b_dayNumber: now.getDate(),
    b_month: now.getMonth() + 1,
    b_year: now.getFullYear(),
    b_timeZone: -(now.getTimezoneOffset() / 60),
  });

  const body = urlEncodeForm(formData);
  const loginConfig = getLoginConfigByRegion(region);

  return function loginAction(dispatch, getState) {
    const state = getState();
    const errorReporter = (error, otherData) => dispatch(
      reportError(error, {
        ...otherData,
        collectionMethod: 'postLogin',
        inauthProfileTransactionId: transactionId,
      })
    );
    const url = `${normalizeApiUrl(getLoginConfig(state, loginConfig))}/myca/logon/${region}/action/login`;

    dispatch({ type: LOGIN_REQUEST });

    return fetchWithReporter(url, {
      method: 'POST',
      headers: {
        'Content-Type': CONTENT_FORM_URL_ENCODED,
        ...challengeable && { challengeable },
      },
      credentials: 'include',
      redirect: 'manual',
      body,
      timeout: 9e3,
      retryCount: 5,
      errorReporter,
      logSuccess: getLogSuccess(state),
    }, state
    )
      .then((response) => {
        // Format the response (or error) as `axp-http-client` does.
        let promise = response.status === 204 ? null : response.json();

        if (!response.ok) {
          const error = new Error(`${response.statusText} (${response.url})`);
          error.response = response;
          promise = promise.then(
            (errorBody) => {
              error.body = errorBody;
              return Promise.reject(error);
            },
            () => Promise.reject(error)
          );
        }

        return promise;
      })
      .then(
        (json) => {
          dispatch({
            type: LOGIN_SUCCESS,
            data: json,
          });
          return json;
        },
        (error) => {
          dispatch({ type: LOGIN_FAILURE });
          throw error;
        }
      );
  };
}

export function sessionLogin(props) {
  return function sessionLoginThunk(dispatch, getState) {
    const state = getState();
    return dispatch(postLogin({
      ...props,
      locale: getActiveLocale(state),
    }))
      .then((response) => {
        dispatch({ type: LOGIN_RESET_STATUS });
        dispatch(updateAuthState({
          shouldTrust: response?.reauth?.trust ?? false,
        }));

        // istanbul ignore else -- allowing ignore else
        if (global.BROWSER && typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem('shouldTrust', response?.reauth?.trust ?? false);
        }

        if (response.statusCode === 0) {
          return response;
        }

        return Promise.reject(response);
      });
  };
}

function getWidgetHandler(locale, state) {
  const region = locale && locale.toLowerCase() === 'en-us' ? 'us' : 'canlac';
  const loginConfig = getLoginConfigByRegion(region);

  const url = `${normalizeApiUrl(getLoginConfig(state, loginConfig))}/myca/scwdg/${region}/widgethandler?`
    + 'widgetName=SessionTimeout&request_type=SessionTimeout&'
    + `json=%7Btype:%27SessionTimeout%27,signal:1%7D&cache=no-cache&Face=${locale}`;

  // using fetch, because we are going to need
  // the response 'Date' header
  return fetch(url, {
    credentials: 'include',
    method: 'get',
  });
}

const endSessionSuccess = () => ({
  type: SESSION_END_SUCCESS,
});

const endSessionFailure = () => ({
  type: SESSION_END_FAILURE,
});

export const setLogoffAlert = (alert) => {
  try {
    window.localStorage.setItem('preAlert', alert);
  } catch (err) {
    // ignore localStorage unsupported
  }
};

// use BAU way of logging out until
// Login Component is released for all markets.
export function endBAUSession() {
  let form;

  function appendField(name, value) {
    const field = document.createElement('input');
    field.setAttribute('type', 'hidden');
    field.setAttribute('name', name);
    field.setAttribute('value', value);
    form.appendChild(field);
  }

  return (dispatch, getState) => {
    const state = getState();
    const locale = getActiveLocale(state);
    const region = getRegionFromLocale(locale) || 'us';
    const oldLocale = loginFaceMapper(locale.replace('-', '_'));

    const loginConfig = getLoginConfigByRegion(region);
    const url = `${normalizeApiUrl(getLoginConfig(state, loginConfig))}/myca/logon/${region}/action`;

    form = document.createElement('form');
    form.setAttribute('method', 'get');
    form.setAttribute('action', url);
    appendField('request_type', 'LogLogoffHandler');
    appendField('Face', oldLocale);
    document.body.appendChild(form);
    form.submit();
    dispatch(endSessionSuccess());
    return Promise.resolve();
  };
}

export function onSuccess(response, auto) {
  return (dispatch) => {
    try {
      if (response.status === 200) {
        dispatch(endSessionSuccess());
      } else {
        dispatch(endSessionFailure());
        dispatch(reportError(new Error(`Logoff API failed with status ${response.status}`), {
          response,
          auto,
          dependencyId: 'one-identity-ducks',
        }));
      }
    } catch (error) {
      dispatch(endSessionFailure());
      dispatch(reportError(new Error('Something went wrong in onSuccess function'), {
        error,
        response,
        auto,
        dependencyId: 'one-identity-ducks',
      }));
    }
  };
}

function onFailure(error, auto) {
  return (dispatch) => {
    dispatch(endSessionFailure());
    dispatch(reportError(new Error('Logoff failure'), {
      error,
      auto,
      dependencyId: 'one-identity-ducks',
    }));
  };
}

// set auto to true if session is being automatically logged out
export function endSession(auto = false) {
  return (dispatch, getState) => {
    const state = getState();
    const locale = getActiveLocale(state);
    const config = getLoginUsApiDomainConfig(state);

    if (!isLoginEnabled(locale)) {
      return dispatch(endBAUSession());
    }
    // until finally() arrives
    return postLogout(locale, config)
      .then((response) => dispatch(onSuccess(response, auto)))
      .catch((error) => dispatch(onFailure(error, auto)))
      .then(() => {
        preload(auto);
        reload();
      });
  };
}

export class Form {
  constructor(url, method) {
    this.form = document.createElement('form');
    this.form.setAttribute('method', method || 'post');
    this.form.setAttribute('action', url);
  }

  appendField(name, value) {
    const field = document.createElement('input');
    field.setAttribute('type', 'hidden');
    field.setAttribute('name', name);
    field.setAttribute('value', value);
    this.form.appendChild(field);
  }

  submit() {
    // may be required for some browsers
    document.body.appendChild(this.form);
    this.form.submit();
  }
}

export function devicePrint(rsa, form) {
  if (typeof rsa !== 'undefined' && typeof rsa.encode_deviceprint === 'function') {
    form.appendField('devicePrint', rsa.encode_deviceprint());
  }
}

// eslint-disable-next-line max-params -- stupid rule
export function legacyLogin(userId, password, remember, uuid, target) {
  return (dispatch, getState) => {
    const state = getState();
    const locale = getActiveLocale(state);
    const region = getRegionFromLocale(locale);
    const oldLocale = loginFaceMapper(locale.replace('-', '_'));
    const now = new Date();

    const loginConfig = getLoginConfigByRegion(region);
    const acctSelectedURL = `/myca/logon/${region}/action/LogLogonHandler?request_type=LogLogonHandler&location=us_logon1`;
    const url = `${normalizeApiUrl(getLoginConfig(state, loginConfig))}${acctSelectedURL}`;

    const form = new Form(url, 'post');
    form.appendField('Face', oldLocale);
    form.appendField('Logon', 'Logon');
    form.appendField('ReqSource', '');
    form.appendField('checkboxValueID', '');
    form.appendField('TARGET', target);
    form.appendField('DestPage', target);
    form.appendField('act', 'soa');
    form.appendField('brandname', '');
    form.appendField('USERID', '');
    form.appendField('PWD', '');
    form.appendField('errMsgValueInPage', false);
    form.appendField('errMsgValue', '');
    form.appendField('isDestFound', 'destNotFound');
    form.appendField('UserID', userId);
    form.appendField('Password', password);
    form.appendField('inauth_profile_transaction_id',
      `USLOGON-${uuid}`);
    form.appendField('corelationID', uuid);
    form.appendField('b_hour', now.getHours());
    form.appendField('b_minute', now.getMinutes());
    form.appendField('b_second', now.getSeconds());
    form.appendField('b_dayNumber', now.getDate());
    form.appendField('b_month', now.getMonth() + 1);
    form.appendField('b_year', now.getFullYear());
    form.appendField('b_timeZone', -(now.getTimezoneOffset() / 60));
    form.appendField('REMEMBERME', rememberMe(remember));
    devicePrint(window.RSA, form);

    form.submit();

    return dispatch({
      type: LEGACY_LOGIN_REQUEST,
    });
  };
}

// perform a legacy ssoLogin form post
// this will take user to the non-SPA world
// eslint-disable-next-line max-params -- stupid rule
export function ssoLogin(userId, password, brandname, remember, target, loginUrl) {
  return (dispatch, getState) => {
    const state = getState();
    const locale = getActiveLocale(state);
    const oldLocale = loginFaceMapper(locale.replace('-', '_'));

    const url = `${loginUrl}?ssolang=${oldLocale}&ssobrand=${brandname}`;

    const form = new Form(url, 'post');
    form.appendField('Face', oldLocale);
    form.appendField('brandname', brandname);
    form.appendField('TARGET', target);
    form.appendField('USERID', userId);
    form.appendField('PWD', password);
    form.appendField('REMEMBERME', rememberMe(remember));

    form.submit();

    return dispatch({
      type: SSO_LOGIN_REQUEST,
    });
  };
}

export function extendSession() {
  return (dispatch, getState) => {
    const state = getState();
    const locale = getActiveLocale(state);
    const config = getLoginUsApiDomainConfig(state);

    dispatch({
      type: SESSION_EXTEND_REQUEST,
    });

    return getWidgetHandler(locale, state)
      .then((response) => {
        if (!response.ok) {
          return dispatch({
            type: SESSION_EXTEND_FAILURE,
          });
        }
        const serverTime = new Date(response.headers.get('Date')).getTime();
        dispatch({
          type: SET_LOCAL_DELTA,
          delta: serverTime - Date.now(),
        });
        return response.json();
      })
      .then((data) => {
        if (data.status === 1) {
          return dispatch({
            type: SESSION_EXTEND_SUCCESS,
          });
        }
        dispatch({
          type: SESSION_EXTEND_FAILURE,
        });
        return postLogout(locale, config);
      });
  };
}

export function setDestPage(destPage) {
  return {
    type: SET_DEST_PAGE,
    destPage,
  };
}

export function clearDestPage() {
  return { type: CLEAR_DEST_PAGE };
}

// Utility functions for handling login success from login or two-step-verification
export const LOGIN_URL = '/login';

export function locationReplace(href) {
  window.location.replace(href);
}

export function locationAssign(href) {
  window.location.assign(href);
}

export function reduxReplace(href) {
  // eslint-disable-next-line global-require -- old code
  const parsedHref = require('url').parse(href);
  browserHistory.replace({
    pathname: parsedHref.path,
    search: parsedHref.search,
    host: parsedHref.host,
    protocol: parsedHref.protocol,
    state: parsedHref,
  });
}

export function redirect(win, href) {
  if (typeof win !== 'undefined') {
    if (href === LOGIN_URL) {
      exports.locationReplace(href);
    } else {
      exports.locationAssign(href);
    }
  } else {
    exports.reduxReplace(href);
  }
}

// redirect user to supplied url or route,
export function setAppLocation(url, doReplace) {
  return () => {
    if (typeof url === 'string') {
      let href = decodeURIComponent(url);
      if (href.toLowerCase().startsWith('http')) {
        return exports.redirect(window, href);
      }
      // treat as a route - should start with slash, otherwise
      // user lands on /login/href instead of /href
      if (!href.startsWith('/')) {
        href = `/${href}`;
      }
      return doReplace
        ? browserHistory.replace(href)
        : browserHistory.push(href);
    }
    return {};
  };
}

initialize();

export default reducer;
